import { createFileRoute } from "@tanstack/react-router";
import { AgentsPage } from "@/features/agents/agents-page";

export const Route = createFileRoute("/_app/automation/agents/")({
  head: () => ({ meta: [{ title: "Agents · Malfak" }] }),
  component: AgentsPage,
});
